<script>
    export let marginBottom;
</script>

<div 
    class="row section" 
    id={$$props.id}
    style="--prop-marginBottom: {marginBottom}px"
>
    <slot name="content">No content</slot>
</div>

<style lang="less">
    :global .section {
        padding: 25px 0;
        display: inline-block;
        
        h2 {
            color: var(--color-gray-200);
        }
    }

    .section {
        margin-bottom: var(--prop-marginBottom);

        @media screen and (max-width: 768px) {
            margin-bottom: calc( var(--prop-marginBottom) / 2 )
        }
    }
</style>